import { FC, useState } from "react";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { NotificationType } from "../../../../domain/enums/NotificationTypeEnum";
import StarsRating from "../../../resources/components/review-components/StarsRating";
import ReceivedCommentIconSVG from "../../../resources/svg/ReceivedCommentIconSVG";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";
import ReviewPopup from "../../../resources/components/review-components/ReviewPopup";

interface ReviewReceivedCardProps {
    notification: NotificationDTO;
}

const ReviewReceivedCard: FC<ReviewReceivedCardProps> = (props) => {
    const { t } = useTranslation();
    const { upTo800, moreOrEqual800 } = useScreenSize();

    const [isVisible, setVisible] = useState(false);

    return (
        <>
            <ReviewPopup isVisible={isVisible} setVisible={setVisible} notification={props.notification} />
            <div
                onClick={() => setVisible(true)}
                className="flex w-full bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.16)] rounded-[10px] py-9 dmax2:py-5 px-10 dmax2:px-4 cursor-pointer transition duration-300"
            >
                <ReceivedCommentIconSVG className="min-w-8 dmax2:min-w-6 min-h-8 dmax2:min-h-6 text-textFaded mr-6 dmax2:mr-3" />
                <div className="flex flex-col w-full">
                    <div className="flex justify-between">
                        <span className="H24B dmax2:H16B text-textWhite text-left max-w-[550px] line-clamp-2">
                            {t(`notifications.${NotificationType.REVIEW_RECEIVED}`)}
                        </span>
                        {moreOrEqual800 && (
                            <span className="H16 dmax2:H14 text-textFaded">
                                {getNotificationCreatedTime(t, props.notification, true)}
                            </span>
                        )}
                    </div>
                    <span className="H20B dmax2:H14B text-textWarning text-left mt-4 dmax2:mt-2 [word-break:break-word]">
                        {props.notification.review?.work.title}
                    </span>
                    <StarsRating wrapClassName="mt-3" rate={props.notification.review?.rate} />
                    <span className="H16 H14 text-textFaded text-left mt-2 dmax2:mt-1 [word-break:break-word]">
                        {props.notification.review?.comment}
                    </span>
                    {upTo800 && (
                        <span className="H16 dmax2:H14 text-textFaded text-end mt-2">
                            {getNotificationCreatedTime(t, props.notification, true)}
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};

export default ReviewReceivedCard;
